<template lang="pug">
 .popup__overlay
  .popup__view
    .popup__body
      .popup__close(@click="close")
        icon(name="close")
      .popup__header(v-if="ticketId") {{$t('cancelPopup.ticketCancel')}}
      .popup__header(v-else) {{$t('cancelPopup.orderCancel')}}
      .popup__main
        .cancel-label(v-if="ticketId") {{$t('cancelPopup.ticketSure')}}
        .cancel-label(v-else) {{$t('cancelPopup.orderSure')}}

        .popup__footer.text-center
          .row
            button.button.button_primary(@click="cancel") {{$t('common.yes')}}
            button.button.button_primary-outline(@click="close") {{$t('cancel')}}
</template>

<script>
import icon from '@/components/Icons.vue';
import API from '@/api/api';

export default {
  props: ['orderId', 'ticketId'],
  components: {
    icon,
  },
  mounted() {
    console.log(this.orderId, this.ticketId);
  },
  methods: {
    close() {
      this.$emit('close');
    },
    cancel() {
      if (this.orderId && this.ticketId) {
        this.cancelTicket();
      } else {
        this.cancelOrder();
      }
    },
    async cancelTicket() {
      const data = await API.deleteTicket(this.orderId, this.ticketId, () => {
        this.commonError();
      });
      if (data) {
        this.$emit('onCancel');
      } else {
        this.commonError();
      }
    },
    async cancelOrder() {
      const data = await API.deleteOrder(this.orderId, () => {
        this.commonError();
      });
      if (data) {
        this.$emit('onCancel');
      } else {
        this.commonError();
      }
    },
    commonError() {
      alert('Something went wrong, try again later'); // eslint-disable-line
      this.$emit('onCancel');
    },
  },
};
</script>

<style lang="scss">
.cancel-label{
  padding-bottom: 2rem;
}
</style>
